import { useEffect, useState } from 'react';
import AppSelect from '@/components/ui/app-select';
import { inputCls, labelCls } from '@/components/finance/Modal';
import { get } from '@/utils/service';
import { apiMessage, shortDate } from '@/utils/api';
import type { Paginated } from '@/utils/finance';

interface Choice { id: string; invoice_number: string; issued_date: string; status: string }
export default function IncomeStartInvoiceEditor({ contractId, value, onChange, disabled = false }: { contractId: string; value: string; onChange: (value: string) => void; disabled?: boolean }) {
  const [choices, setChoices] = useState<Choice[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    setLoading(true); setError(''); setChoices([]);
    (async () => {
      const all: Choice[] = [];
      let page = 1;
      while (true) {
        const response = await get<Paginated<Choice>>('/invoices', { contract_id: contractId, page, page_size: 100, sort: 'issued_date' });
        if (!live) return;
        all.push(...response.data.filter((invoice) => invoice.status !== 'cancelled'));
        if (page >= response.pagination.total_pages) break;
        page++;
      }
      setChoices(all);
    })().catch((failure) => { if (live) setError(apiMessage(failure, 'Could not load income invoice options.')); }).finally(() => { if (live) setLoading(false); });
    return () => { live = false; };
  }, [contractId]);
  return <div className="space-y-2"><label className={labelCls}>Starting income invoice</label><AppSelect className={inputCls} value={value} disabled={disabled || loading || !!error} onChange={(event) => onChange(event.target.value)}><option value="">Include all invoices</option>{choices.map((invoice) => <option key={invoice.id} value={invoice.id}>{invoice.invoice_number} · {shortDate(invoice.issued_date)}</option>)}</AppSelect><p className="text-xs text-gray-500">Income totals include this invoice and invoices issued on or after its date. Earlier invoices and payment records remain available. You can change or clear this selection later.</p>{error && <p role="alert" className="text-xs text-red-600">{error}</p>}</div>;
}
